import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    /* Border */
    st12: (props) => {
        const {
            backgroundColor,
        } = props;

        return {
            fill: backgroundColor || '#00A8E2',
            filter: 'brightness(0.85)',
        };
    },

    /* Background */
    st0: (props) => {
        const {
            backgroundColor,
        } = props;

        return {
            fill: backgroundColor || '#00A8E2',
        };
    },

    /* font color */
    st1: (props) => {
        const {
            fontColor,
        } = props;

        return {
            fill: fontColor || '#FFFFFF',
        };
    },

    st2: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st3: {
        fontSize: '15px',
        // fontWeight: '600',
    },

    st4: {
        clipPath: 'url(#SVGID_2_)',
    },

    st13: {
        fill: '#FFFFFF',
    },

}));
